import axios from "axios";
import cookie from "react-cookies";

const API_URL = process.env.REACT_APP_API_URL

const blended_wizportal = axios.create({
    baseURL: `${API_URL}/wizportal/`,
    timeout: 25000,
})

const blended_wizportal_validation = axios.create({
    baseURL: `${API_URL}/wizportal/`,
    timeout: 25000,
})

blended_wizportal.interceptors.request.use(config => {
    let sessionToken = cookie.load('token_info')
    if (sessionToken){
        const tokenType = sessionToken.token_type
        const accessToken = sessionToken.access_token
        config.headers['Authorization'] = tokenType + " " + accessToken
    }
    return config
}, error => Promise.reject(error))

export async function getUserFromJWT(jwtToken) {

    // Split the JWT into its parts
    const parts = jwtToken.split('.');
    if (parts.length !== 3) {
        throw new Error('Invalid JWT format');
    }

    // Decode the payload (the second part of the JWT)
    const encodedPayload = parts[1];
    const decodedPayload = JSON.parse(atob(encodedPayload));

    // Extract the "ppl" claim (or adjust to your payload structure)
    const userData = decodedPayload || {};

    // Optional: Check if required fields are present
    const requiredFields = ['external_user_id', 'book_id', 'username', 'email', 'first_name', 'last_name'];
    for (const field of requiredFields) {
        if (!(field in userData)) {
            throw new Error(`Missing required field: ${field}`);
        }
    }

    return {
        "id": userData.external_user_id,
        "first_name": userData.first_name,
        "last_name": userData.last_name,
        "username": userData.username,
        "email": userData.email,
        "book": userData.book_id,
        "lesson_id": userData.lesson_id,
        "data": {
            "key_sessao": "",
            "birth_date": null,
            "gender": null,
            "external_user_id": userData.external_user_id,
            "phone_number": null,
            "cell_phone": null,
            "notify_at": null,
            "scholarity": null,
            "occupation": null,
            "income_range": null,
            "main_objective": null,
            "expected_outcome": null,
            "has_previous_courses": null,
            "has_smartphone": null,
            "has_pc": null,
            "assistant_language": null,
            "rg": null,
            "cpf": null,
            "available_languages": [
                {
                    "code": "en",
                    "name": "Inglês"
                },
            ],
            "region_user": "BRA",
            "region_code": "en"
        }
    }
}

export async function validateJWT(data) {
    const response =  await blended_wizportal_validation({
        method: "GET",
        url: "/jwt_validate",
        headers: {
            Authorization: `Bearer ${data.jwtToken}`
        }
    });

    if(response.status !== 200) {
        throw new Error('Invalid JWT');
    }

    return response.data;
}

export function getCourseById(courseId) {
    return blended_wizportal({
        method: 'GET',
        url: `/courses/${courseId}`,
    })
}

export function setWizportalAuth(tokenType, accessToken) {
    blended_wizportal.defaults.headers.common['Authorization'] = `${tokenType} ${accessToken}`;
}